module.exports = __webpack_public_path__ + "static/img/role.1c013a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/role3/ch/role.png
// module id = SL2O
// module chunks = 7